import * as React from 'react'
import type { SVGProps } from 'react'
import { type Ref, forwardRef } from 'react'
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMalekLogo = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <mask
      id='malek-logo_svg__a'
      width={20}
      height={18}
      x={2}
      y={3}
      maskUnits='userSpaceOnUse'
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill='#000'
        fillRule='evenodd'
        d='m13.838 12.353 2.132-3.676h1.785l-3.488 6.042c-.215.37-.611.6-1.04.6H6.251l.893-1.548h4.036a3.2 3.2 0 0 0 2.658-1.419m4.409-5.676h-1.123l.561-.974c.62-1.073-.247-2.573-1.486-2.573H8.73a3.2 3.2 0 0 0-2.77 1.6l-3.735 6.468c-.62 1.075.248 2.573 1.486 2.573h1.125l-.563.974c-.62 1.075.248 2.573 1.486 2.573h1.126l-.564.976c-.62 1.075.248 2.573 1.486 2.573h7.468a3.2 3.2 0 0 0 2.658-1.419l3.848-6.65c.62-1.072-.247-2.572-1.486-2.572H19.17l.562-.976c.62-1.073-.247-2.573-1.486-2.573m-.232 5.549-2.13 3.673a3.2 3.2 0 0 1-2.658 1.42H9.193L8.3 18.866h6.976a1.2 1.2 0 0 0 1.04-.6l3.488-6.041zM8.73 5.13a1.2 1.2 0 0 0-1.039.6L4.203 11.77h6.977a1.2 1.2 0 0 0 1.039-.6l3.488-6.041z'
        clipRule='evenodd'
      />
    </mask>
    <g mask='url(#malek-logo_svg__a)'>
      <path fill={props.color} d='M0 0h24v24H0z' />
    </g>
  </svg>
)
const ForwardRef = forwardRef(SvgMalekLogo)
export default ForwardRef
